import { isMainRow } from "Pages/AnalyzersV2/@components/Table/@utils"

const ROW_META_KEYS = ['name', 'nameFilter', 'nameIcon', 'nameMarket']

/**
 * Display name of the main provider, taken from the row flagged as main.
 *
 * `nameFilter` is what the table prints — the brand without its domain — while
 * `name` keeps the raw alias, so the two must not be mixed on screen.
 */
export const findMainName = (trows = []) => {
	const row = trows.find(isMainRow)

	return row?.nameFilter || row?.name || null
}

/** Currency label shared by every price cell, read from the first one available. */
export const findCurrency = (trows = []) => {
	for (const row of trows) {
		for (const [key, cell] of Object.entries(row)) {
			if (ROW_META_KEYS.includes(key)) continue

			const currency = cell?.price_data?.id_master_currency_translation
			if (currency) return currency
		}
	}

	return null
}
